<template>
  <div
    style="
      display: flex;
      flex-direction: column;
      width: 100%;
      align-items: center;
    "
  >
    <v-btn
      :color="currentCalendar.color"
      height="40px"
      elevation="5"
      variant="tonal"
      style="border: 0.01px; margin-bottom: 2%"
      prepend-icon="mdi-plus"
      >Create
      <v-menu activator="parent">
        <v-list>
          <v-list-item @click="addEvent()" v-if="canEditCalendar && !isODCalendar" >Event</v-list-item>
          <v-list-item v-if="isAdmin" @click="createCalendar()">Calendar</v-list-item>
        </v-list>
      </v-menu>
    </v-btn>
    <v-icon :color="currentCalendar.color" v-if="isMobile && currentCalendar?.color" size="30" @click="openCalendar()">mdi-arrow-right-circle</v-icon>
    <vue-cal
      date-picker
      :views-bar="false"
      @update:selectedDate="selectDate($event)"
      :style="{ '--vuecal-primary-color': currentCalendar.color }"
    />

    <v-container>
      <v-select
        v-model="currentCalendar"
        label="Choose Calendar"
        :items="calendarList"
        item-value="calendar_id"
        item-title="name"
        @update:model-value="handleSelectCalendar"
        variant="outlined"
        density="compact"
        rounded
      >
        <template v-slot:item="{ item, props }">
          <div
            v-bind="props"
            :style="{
              display: 'flex',
              alignItems: 'center',
              padding: '5px 8px',
              cursor: 'pointer',
            }"
          >
            <v-icon class="mr-2" size="15" :color="item.raw.color">
              mdi-calendar
            </v-icon>
            <span :style="{ textAlign: 'left', flex: 1 }">
              {{ item.raw.name }}
            </span>
          </div>
        </template>
        <template v-slot:selection="{ item }">
          <v-icon class="mr-2" size="15" :color="item.raw.color">
            mdi-calendar
          </v-icon>
          <span>{{ item.raw.name }}</span>
        </template>
      </v-select>
    </v-container>
    <v-text-field
      v-if="showSearch"
      v-model="searchText"
      class="align-self-stretch"
      label="Search Members"
      variant="underlined"
      prepend-inner-icon="mdi-magnify"
    >
      <template v-slot:append-inner>
        <v-icon
          size="20"
          icon="mdi-close"
          @click="showSearch = false; searchText=''"
          style="cursor: pointer; opacity: 0.5"
        ></v-icon>
      </template>
    </v-text-field>
    <v-toolbar v-if="!showSearch" density="compact" title="Members" :color="lightenColor(currentCalendar.color)">
      <template v-slot:append>
        <div class="d-flex ga-1">
          <v-icon
            size="20"
            icon="mdi-magnify"
            @click="showSearch = true"
          ></v-icon>

          <v-icon v-if="canEditCalendar" size="20" icon="mdi-account-plus-outline" @click="addNewMembers = !addNewMembers"></v-icon>
        </div>
      </template>
    </v-toolbar>

    <div style="width: 100%; height: 200px; display: flex; overflow-y: visible">
      <RecycleScroller
        :items="filteredMembers"
        :item-size="45"
        style="flex: 1 1 100px; overflow-y: auto; overflow-x: hidden"
        v-slot="{ item }"
        key-field="user_id"
      >
        <v-hover v-slot="{ hover }">
          <div
            :class="{ hovered: hover }"
            style="display: grid; align-items: center"
            class="unselectable px-3"
          >
            <div style="grid-area: 1/1/1/1; justify-self: start">
              <UserPopup :user_id="item.user_id" :tooltip="false" />
            </div>
            <div
              style="grid-area: 1/1/1/1; justify-self: left; margin-left: 55px"
              class="text-center"
            >
              <div>
                {{ getUserName(item.user_id) }}
              </div>
              <div v-if="!addNewMembers" class="text-caption" style="color: #757575">
                {{ item.role }}
              </div>
            </div>
            <div style="grid-area: 1/1/1/1; justify-self: end">
              <div style="display: inline-flex; vertical-align: middle">
            
                <v-dialog max-width="500">
                  <template v-slot:activator="{ props }">
                    <v-icon
                      v-if="item.role !== CALENDAR_ROLES.OWNER && canEditCalendar"
                      v-bind="props"
                      size="small"
                      color="secondary"
                      style="opacity: 0.5"
                      >{{addNewMembers ? 'mdi-account-plus-outline' : 'mdi-cog-outline'}}</v-icon
                    >
                  </template>

                  <template v-slot:default="{ isActive }">
                    <v-card rounded="lg">
                      <v-card-title
                        class="d-flex justify-space-between align-center"
                      >
                        <div>{{ addNewMembers ? 'Add' : 'Update' }} Member</div>
                        <v-btn
                          icon="mdi-close"
                          variant="text"
                          @click="isActive.value = false"
                        ></v-btn>
                      </v-card-title>

                      <v-divider></v-divider>

                      <v-card-text>
                        <v-container fluid>
                          <v-radio-group v-model="item.role">
                            <template v-slot:label>
                              <div>Select Permissions</div>
                            </template>
                            <v-radio :value="CALENDAR_ROLES.VIEWER">
                              <template v-slot:label>
                                <div>
                                  Viewer
                                  <v-icon style="opacity: 0.5">mdi-eye</v-icon>
                                </div>
                              </template>
                            </v-radio>
                            <v-radio :value="CALENDAR_ROLES.EDITOR">
                              <template v-slot:label>
                                <div>
                                  Editor
                                  <v-icon style="opacity: 0.5"
                                    >mdi-lead-pencil</v-icon
                                  >
                                </div>
                              </template>
                            </v-radio>
                          </v-radio-group>
                        </v-container>
                      </v-card-text>

                      <v-divider class="mt-2"></v-divider>

                      <v-card-actions class="my-2 d-flex">
                        <v-btn
                          v-if="!addNewMembers"
                          class="text-none"
                          rounded="xl"
                          color="red"
                          text="Remove Member"
                          @click="removeCalendarMember(item), (isActive.value = false)"
                        ></v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          class="text-none"
                          rounded="xl"
                          text="Cancel"
                          @click="isActive.value = false"
                        ></v-btn>

                        <v-btn
                          class="text-none"
                          color="success"
                          rounded="xl"
                          :text="addNewMembers ? 'Add' : 'Update'"
                          variant="flat"
                          @click="handleCalendarMember(item), (isActive.value = false)"
                        ></v-btn>
                      </v-card-actions>
                    </v-card>
                  </template>
                </v-dialog>
              </div>
            </div>
          </div>
        </v-hover>
      </RecycleScroller>
    </div>
    <span
      style="font-size: medium; margin-bottom: 3%; margin-top: 4%"
      class="text-medium-emphasis"
      >Calendar Description</span
    >
    <p>
      {{ currentCalendar?.description || "No description available" }}
    </p>
  </div>
</template>
<script>

import { VueCal } from "vue-cal";
import "vue-cal/style";
import EventBus from "@/eventBus";
import { mapGetters, mapActions, mapMutations } from "vuex";
import { CALENDAR_ROLES } from "../../constants/constantsValues.js";
import CalendarService from "@/services/calendarService.js";
import colorMixin from "@/mixins/colorMixin";
export default {
  
  name: "CaledarLeftPanel",
  data() {
    return {
      selectedDate: null,
      CALENDAR_ROLES,
      searchText: "",
      showSearch: false,
      addNewMembers: false,
    };
  },
  mixins : [colorMixin],
  components: {
    VueCal,
  },
  computed: {
    ...mapGetters(['isAdmin']),
    ...mapGetters("window", ["isMobile"]),
    ...mapGetters("people", ["getUserName","users"]),
    ...mapGetters("calendar", ["calendarList", "currentCalendar","canEditCalendar","isODCalendar"]),
    ...mapGetters("openAI", ["getCalendarIntent"]), 

    calendarMembers() {
      if (!this.currentCalendar?.calendar_members?.length) {
        return [];
      }
      if(this.addNewMembers){
        let allUsers = this.users.map(user => ({ user_id: user.user_id, role:  CALENDAR_ROLES.EDITOR }));
        return allUsers.filter((user) => {
          return !this.currentCalendar.calendar_members.some(
            (member) => member.user_id === user.user_id
          );
        });
      }
      return [
        ...this.currentCalendar?.calendar_members.filter(
          (item) => item.role === CALENDAR_ROLES.OWNER
        ),
        ...this.currentCalendar?.calendar_members.filter(
          (item) => item.role !== CALENDAR_ROLES.OWNER
        ),
      ];
    },
    filteredMembers() {
    const text = this.searchText.toLowerCase();
    return this.calendarMembers.filter(member => {
      const name = this.getUserName(member.user_id).toLowerCase();
      const role = member.role.toLowerCase();
      return name.includes(text) || role.includes(text);
    });
  }
  },
  methods: {
    ...mapActions("calendar", [
      "addCalendarMember",
      "updateCalendarMemberRole",
      "removeCalendarMember",
      "getCalendars",
      "getcalendarById",
    ]),
    ...mapMutations("openAI", ["clearCalendarIntent"]), 

    async handleCalendarIntent() {
      const intent = this.getCalendarIntent;
      if (intent && Array.isArray(this.calendarList) && this.calendarList.length) {
        const odCalendar = this.calendarList.find(c => c && c.type === 'OD');
        if (odCalendar) {
          odCalendar.intentDate = intent.date;
          // this.$store.commit('calendar/currentCalendar', odCalendar);
          await this.getcalendarById(odCalendar.calendar_id);
          const formattedDate = new Date(intent.date);
          this.selectDate(formattedDate);
        }
        this.clearCalendarIntent();
      }
    },
    async handleSelectCalendar(item) {
      console.log("SELECTED CALENDAR", item);
      await this.getcalendarById(item);
    },
    openCalendar(){
      EventBus.$emit("close-left-panel")
    },
    addEvent() {
      EventBus.$emit("add-event");
    },
    createCalendar() {
      EventBus.$emit("add-calendar");
    },
    selectDate(item) {
      console.log("DATE", item);

      EventBus.$emit("select-date", item);
    },
    editCalendar(){
       console.log("Edit Calendar");
       EventBus.$emit("edit-calendar");
    },
    async handleCalendarMember(item){
      if(this.addNewMembers){
        // Add New Member
        try {
          let payload = { member_id : item.user_id , role : item.role };
          await CalendarService.addCalendarMember(this.currentCalendar.calendar_id, payload);
        } catch (error) {
          console.log(error);
        }
      }else{
        // Update role
        this.updateCalendarMemberRole(item)
      }
    }
  },
  watch: {
    calendarList: {
      async handler() {
        await this.handleCalendarIntent();
      },
      immediate: true
    }
  },
  async created() {
    await this.getCalendars();
  },
};
</script>
<style scoped></style>
